export default "__VITE_ASSET__C2YqOAbt__"